import {FormControl} from "react-bootstrap";
import React from "react";

export const ReportSelectComponent = (props) => {
	return (
		<tr>
			<td className="sb-model-viewer-column">
				<label>{props.title}</label>
			</td>
			<td className="sb-model-viewer-column">
				{
					props.data === null ?
						<span className="value">Loading...</span> :
						!!props.data?.length ?
							<FormControl
								as="select"
								value={props.value}
								onChange={(x) => props.onChange(x.target.value)}
							>
								<option value="">{props.placeholder}</option>
								{
									props.data?.map((item) => (
										<option key={`${props.title}-${item[props.primaryKey]}`}
										        value={item[props.primaryKey]}>
											{props?.nameLogic?.(item) ?? item.name}
										</option>
									))
								}
							</FormControl> :
							<span className="value">
                                {props.emptyMessage}
                            </span>
				}
			</td>
		</tr>
	)
};